import React from 'react';

import { EmptyState } from 'components/TeamsCommunities/EmptyState';
import personWithHeart from 'assets/person-with-heart.avif';

export function CommunitiesDisabledState(): JSX.Element {
  const description = `👋 Communities aren't enabled on your account (yet). Communities help employees connect around shared identities, causes, or experiences—like ERGs, cultural groups, and more.  👉 Interested in starting Communities at your company? Reach out to your admin or Partner Success Manager to enable this feature.`;

  return (
    <EmptyState title="Communities" description={description} illustration={personWithHeart} />
  );
}
